import React from "react";

const About = () => (
  <section id="about" className="organization-section">
    <div className="organization-container">   
        <div className="organization-column" width="65%">
          <p>
            A Maratona Inter-Universitária de Programação (MIUP) é uma prova de
            programação que tem como destinatários os estudantes do ensino
            superior. A prova é disputada por equipas, com um máximo de 3
            elementos, onde, durante 5 horas as equipas procurarão resolver
            entre 9 e 11 problemas diversos recorrendo às linguagens de
            programação C,C++, Java ou Python.
          </p>
          <p>
            {" "}
            A competição permite que os participantes testem a sua capacidade de
            resolução de problemas, possibilitando, em simultâneo, o convívio e
            a troca de experiências entre alunos e professores das instituições
            de ensino superior portuguesas.
          </p>
          <p>
            {" "}
            Este ano, a MIUP terá lugar na Escola Superior de Tecnologia e
            Gestão de Águeda da Universidade de Aveiro a 26 de Outubro de 2024.
          </p>
        </div>
    </div>
  </section>
);

export default About;